export default {
  selectedAccountIds: [],
  search: null,
  dashboards: [],
  status: 'loading',
  error: null,
  page: 0,
  limit: 100,
};
